"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AiAssistantImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing AiAssistant operations. */
var AiAssistantImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class AiAssistant class.
   * @param client Reference to the service client
   */
  function AiAssistantImpl(client) {
    (0, _classCallCheck2["default"])(this, AiAssistantImpl);
    this.client = client;
  }
  /**
   *  (Auth: RhinestoneAuthorize[portalId])
   * @param portalId (Access Controlled)
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(AiAssistantImpl, [{
    key: "getConfigurations",
    value: function getConfigurations(portalId, options) {
      var operationArguments = {
        portalId: portalId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getConfigurationsOperationSpec);
    }
    /**
     * Endpoint for a single completion without chat context (Auth: RhinestoneAuthorize[portalId])
     * @param portalId (Access Controlled)
     * @param query
     * @param options The options parameters.
     */

  }, {
    key: "completionV1",
    value: function completionV1(portalId, query, options) {
      var operationArguments = {
        portalId: portalId,
        query: query,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, completionV1OperationSpec);
    }
  }]);
  return AiAssistantImpl;
}(); // Operation Specifications


exports.AiAssistantImpl = AiAssistantImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var getConfigurationsOperationSpec = {
  path: "/api/portals/{portalId}/aiAssistant/completion/options",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AiCompletionNamedConfigurationDto"
            }
          }
        }
      }
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var completionV1OperationSpec = {
  path: "/api/portals/{portalId}/aiAssistant/completion/v1",
  httpMethod: "POST",
  responses: {
    200: {
      bodyMapper: Mappers.StreamResponseDto
    },
    401: {},
    403: {},
    404: {}
  },
  requestBody: Parameters.body,
  queryParameters: [Parameters.query],
  urlParameters: [Parameters.$host, Parameters.portalId],
  headerParameters: [Parameters.accept, Parameters.contentType],
  mediaType: "json",
  serializer: serializer
};